import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function DynamicTextRender({ node, isLiveMode, pageData }) {
  const content = node.content || {};
  
  const fieldKey = content.fieldKey || 'title';
  const fallback = content.fallback || 'Seiten-Überschrift';
  const htmlTag = content.htmlTag || 'h1';
  const color = content.color || '#f8fafc';
  const align = content.align || 'left';
  const fontSize = content.fontSize || '32px';

  // Im Designer (isLiveMode=false) haben wir pageData oft nicht global parat, 
  // oder wir wollen bewusst den Platzhalter zeigen.
  // Im Live-Frontend (PageRenderer) wird pageData per Prop durchgeschleift.
  
  let displayText = fallback;
  
  if (isLiveMode && pageData) {
    if (fieldKey === 'title') displayText = pageData.title || fallback;
    else if (fieldKey === 'slug') displayText = pageData.slug || fallback;
    else if (fieldKey === 'status') displayText = pageData.status || fallback;
    // Falls man ein Custom Metadaten-Objekt hat (z.b. pageData.meta.author)
    else if (fieldKey.startsWith('meta.') && pageData.meta) {
      const metaKey = fieldKey.substring(5);
      displayText = pageData.meta[metaKey] || fallback;
    }
  } else if (!isLiveMode) {
    displayText = `[Dynamic: ${fieldKey}]`; // Zeigt explizit an, dass es dynamisch ist
  }

  const styleObj = {
    color: color,
    textAlign: align,
    fontSize: fontSize,
    margin: 0,
    fontWeight: htmlTag.startsWith('h') ? 'bold' : 'normal'
  };

  const Tag = htmlTag;

  return (
    <Tag style={styleObj}>
      {displayText}
    </Tag>
  );
}

// Wir registrieren das Widget so, dass es auch Daten erwartet
registry.register('DynamicText', {
  label: 'Dynamischer Text (CMS)',
  icon: '🖹', 
  category: 'advanced', // oder cms falls wir das als neue cat machen
  component: DynamicTextRender,
  
  defaultProps: {
    content: {
      fieldKey: 'title',
      fallback: 'Dynamischer Titel',
      htmlTag: 'h1',
      color: '#f8fafc',
      align: 'left',
      fontSize: '48px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Daten-Bindung',
          fields: [
            { 
              name: 'content.fieldKey', 
              label: 'Datenfeld', 
              type: 'select', 
              options: ['title', 'slug', 'status', 'meta.author', 'meta.date'] 
            },
            { name: 'content.fallback', label: 'Fallback Text (wenn leer)', type: 'text' }
          ]
        },
        {
          title: 'Darstellung',
          fields: [
            { name: 'content.htmlTag', label: 'HTML Tag', type: 'select', options: ['h1', 'h2', 'h3', 'h4', 'p', 'span'] },
            { name: 'content.color', label: 'Farbe', type: 'color' },
            { name: 'content.fontSize', label: 'Größe', type: 'text' },
            { name: 'content.align', label: 'Ausrichtung', type: 'select', options: ['left', 'center', 'right'] }
          ]
        }
      ]
    }
  ]
});
